import { createRef, useState } from 'react';
import noop from 'lodash/noop';
import PropTypes from 'prop-types';
import { Card, Flex, NakedButton, Icon } from 'roo-ui/components';
import { CollapsableContent } from './primitives';
import { BREAK_POINTS_PX } from 'styles/theme';

function isSmallScreen() {
  return window.innerWidth <= BREAK_POINTS_PX[0];
}

const CollapsableCard = ({ children, onToggle, collapsedHeight, collapsable, scrollUpOnCollapse }) => {
  const [isOpen, toggle] = useState(false);
  const cardRef = createRef();

  const toggleCollapsed = () => {
    toggle(!isOpen);
    onToggle.call(null, !isOpen);

    if (!isOpen === false && scrollUpOnCollapse && isSmallScreen()) {
      cardRef.current.scrollIntoView();
    }
  };

  const ariaLabel = isOpen ? 'Collapse content' : 'Expand content';
  const iconName = isOpen ? 'expandLess' : 'expandMore';

  return (
    <Card p={6} pb={4} mb={[5, 8]} display="flex" flexDirection="column" ref={cardRef}>
      <CollapsableContent className={isOpen || !collapsable ? 'open' : null} collapsedHeight={collapsedHeight}>
        {children}
      </CollapsableContent>
      {collapsable && (
        <NakedButton onClick={toggleCollapsed} color="brand.primary" aria-label={ariaLabel} py="2">
          <Flex>
            {isOpen ? 'View less' : 'View more'}
            <Icon name={iconName} />
          </Flex>
        </NakedButton>
      )}
    </Card>
  );
};

CollapsableCard.propTypes = {
  collapsedHeight: PropTypes.number,
  children: PropTypes.node,
  onToggle: PropTypes.func,
  collapsable: PropTypes.bool,
  scrollUpOnCollapse: PropTypes.bool,
};

CollapsableCard.defaultProps = {
  collapsedHeight: 80,
  collapsable: true,
  scrollUpOnCollapse: true,
  onToggle: noop,
};

export default CollapsableCard;
